export default __webpack_public_path__ + "static/media/browser-safari.64636588.svg";